import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Rating from 'components/shared/Rating';

const Ratings = ({ rating, setRating }) => (
  <>
    <Text variant={TEXT_VARIANTS.BODY} className="mb-8" component="div">
      {t('beta_feedback.rating_subheader')}
    </Text>
    <Rating rating={rating} setRating={setRating} />
    <Text variant={TEXT_VARIANTS.BODY} className="mb-8 mt-16" component="div">
      {t('beta_feedback.additional_feedback')}
    </Text>
  </>
);

export default Ratings;
